import type { IContrato } from "./entidades/IContrato";
import { type ICatalogo, type IFiltroPaginador, type IRespuestaApiLista, type IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";
import type { IClienteContratoHistorial } from "../ClientesContratos/entidades/IClienteContratoHistorial";
import type { IFiltroContrato } from "./entidades/IFiltroContrato";

export class ContratoModelo {
    

    constructor() { }

    public async obtenerContratoFiltros(filtros: IFiltroContrato): Promise<IRespuestaApiObjeto<IContrato>> {
        const { data } = await api.post(
            `/api/Contratos/ObtenerPorIdCompuesto`, filtros, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async obtenerListaContratosCompuesto(): Promise<IRespuestaApiLista<IContrato>> {
        const { data } = await api.get(
            `/api/Contratos/ListarCompuesto`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        // data.Data = data.Data.filter((contrato: IContrato) => contrato.ProyectoId === idProyecto);
        return data;
    }

    public async obtenerListaHistorialClientesCompuesto(proyectoId: number, filtroPaginador: IFiltroPaginador): Promise<IRespuestaApiLista<IContrato>> {
        const { data } = await api.get(
            `/api/HistorialClienteContratoProyectos/ListarCompuesto`, {
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                proyectoid: proyectoId,
                page: filtroPaginador.Page,
                size: filtroPaginador.Size
            },
        });

        const lista = Array.isArray(data.Data) ? data.Data : [];

        data.Data = lista
            .map((item: IClienteContratoHistorial) => item.ContratoAnterior)
            .filter((contrato: IContrato): contrato is IContrato => contrato != null);

        return data;
    }

    public async crearContrato(contrato: IContrato): Promise<IRespuestaApiObjeto<IContrato>> {
        const { data } = await api.post(
            `/api/Contratos/Crear`, contrato, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async editarContrato(contrato: IContrato): Promise<IRespuestaApiObjeto<IContrato>> {
        const { data } = await api.put(
            `/api/Contratos/Actualizar`, contrato, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async eliminarContrato(contrato: IContrato): Promise<IRespuestaApiObjeto<boolean>> {
        const { data } = await api.delete(
            `/api/Contratos/Actualizar/${contrato.Id}`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async consultarTiposContrato(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
            `/api/TipoContratos/Listar`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;

    }
}

